// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"file-attachment"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20 11V7L15 2H4V22H12M14 2V8H20","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M19 19V15.5C19 14.6716 18.3284 14 17.5 14C16.6716 14 16 14.6716 16 15.5V20C16 21.6569 17.3431 23 19 23C20.6569 23 22 21.6569 22 20V16.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-file-attachment')
export default class FileAttachmentIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-attachment',
    }
  }
}
